import { Directive } from '@angular/core';

@Directive({ selector: '[gorPageHeaderBottom]' })
export class PageHeaderBottomDirective {}
